import React from 'react';
import Form from '../common/form';
import Joi from 'joi-browser';
import data from '../../configs/config';
import { login, sso_login } from '../../services/authService';
import { pwd_pattern } from './../../utils/constants';
import { NavLink } from 'react-router-dom';
import { defaults } from '../common/toast';

class LoginForm extends Form {
  state = {
    data: { username: '', password: '' },
    errors: {}
  };

  schema = {
    username: Joi.string().email().max(254).required().label('Username'),
    password: Joi.string().regex(pwd_pattern).required().label('Password')
  };

  doSubmit = async () => {
    try {
      await login(this.state.data);
      const { state } = this.props.location;
      window.location = state ? state.from.pathname : '/';
    } catch (err) {
      const errors = { ...this.state.errors };
      if (err.response) {
        if (err.response.status === 400) errors.password = err.response.data;
        if (err.response.status === 401)
          errors.password = err.response.data.detail;
      } else {
        errors.password = data.connectionerror;
      }
      this.setState({ errors });
    }
  };

  submitSSO = async () => {
    try {
      const response = await sso_login();
      window.location.href = response.request.responseURL;
    } catch (err) {
      console.log('SSO login failed', err);
    }
  };

  forgotpassword = () => {
    defaults('Contact the admin to reset your password');
  };

  render() {
    const showFormLogin = data.form_auth;
    const showSSOLogin = data.sso_auth;

    return (
      <div className='login-form-container'>
        {showFormLogin && (
          <form onSubmit={this.handleSubmit}>
            {this.renderInput(
              'username',
              'Enterprise ID',
              'Enter your accenture email',
              'text',
              'User'
            )}
            {this.renderInput(
              'password',
              'Password',
              'Enter the password',
              'password',
              'Lock'
            )}
            <p className='redirects'>
              <span className='forgot-password' onClick={this.forgotpassword}>
                Forgot Password?
              </span>
              {' | '}
              <NavLink className='forgot-password' to='/reset-password'>
                Password Expired?
              </NavLink>
            </p>
            {this.renderButton('Login', false, '100%', '0.5rem 0 0')}
          </form>
        )}

        {showSSOLogin && (
          <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
            <button
              className='btn btn-primary'
              style={{ width: '100%' }}
              onClick={this.submitSSO}
            >
              Login with SSO
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default LoginForm;
